// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1DXvA","item":"PaymentsMobile_item__1dJLs","label":"PaymentsMobile_label__1l2RC","amount":"PaymentsMobile_amount__1XpME"};